import type { IService } from 'restangular'

import { app } from '../../app.module'

/**
 * イベントのタグを編集するchipsのフォーム。
 * イベントを選択時に、親スコープにイベントを送信する
 * attribute: なし
 */
class EventTagChipsComponentCtrl {
  private Restangular: IService
  private scope: ng.IScope
  private suggestTags: {}[]
  private selectedTags: {
    tagId: number
  }[]

  constructor($scope, Restangular) {
    this.scope = $scope
    this.Restangular = Restangular

    this.selectedTags = []
    // オートコンプリートのタグを全て取得する
    this.getAllTags()

    // 編集としてモーダルが呼ばれた際は、既存のタグをセットする
    this.scope.$on('setEventData', (event, eventData) => {
      this.selectedTags = eventData.tags
    })
  }

  /**
   * タグが入力された場合は、タグIDを送信する
   */
  public addTag() {
    this.sendEvent()
  }

  /**
   * タグが削除された場合は、タグIDを送信する
   */
  public removeTag() {
    this.sendEvent()
  }

  /**
   * タグ入力を全て受け付けないようにする
   * @param  {object | string} chip フォームに入力された値
   */
  public preventTyping(chip: string | {}) {
    if (typeof chip === 'string') {
      return null
    }
    return chip
  }

  /**
   * 全ての投稿タグを取得する
   */
  private getAllTags() {
    this.Restangular.all('/event/getAllGlobalPostTags')
      .getList()
      .then((selectedTags) => {
        this.suggestTags = selectedTags[0].data
      })
  }

  /**
   * 親コンポーネントに、付けられたタグとともにイベントを送信する
   */
  private sendEvent() {
    // タグを何もつけていない場合は、nullを送信する
    let sendData

    if (this.selectedTags.length === 0) {
      sendData = null
    } else {
      sendData = this.selectedTags
    }
    this.scope.$emit('changeEventTagChips', sendData)
  }
}

app.component('eventTagChips', {
  template: require('./event-tag-chips.pug')(),
  controller: EventTagChipsComponentCtrl,
})
